const DEATH_STONE_SHOW_TYPES = {
  HAIFONG: 'HAIFONG',
  NORMAL: 'NORMAL',
};

export default DEATH_STONE_SHOW_TYPES;
